var map = {
	"./Refresh.png": "e3a8",
	"./SupportTicket.svg": "a61d",
	"./account.svg": "19a8",
	"./activity.svg": "c11a",
	"./agency.png": "af6c",
	"./agency.svg": "de1c",
	"./arrow-level.svg": "ac19",
	"./arrow-up-filling.png": "01c2",
	"./arrow.svg": "5975",
	"./arrows.png": "4a16",
	"./back.png": "2100",
	"./bag-icon.svg": "f37b",
	"./balance.svg": "9089",
	"./blog.png": "fdfa",
	"./box.png": "79d0",
	"./burn.png": "1e0e",
	"./camera.svg": "d24a",
	"./check.png": "1ecc",
	"./circular-arrow.png": "2d82",
	"./clearH.svg": "9840",
	"./close-white.png": "eef1",
	"./close.png": "9c84",
	"./copy-2.png": "7cd3",
	"./copy.png": "5a0e",
	"./cup.png": "7710",
	"./dashboard.png": "f9a0",
	"./dot-icon.png": "cef1",
	"./drop-2.png": "3856",
	"./drop-new.svg": "9a40",
	"./drop.png": "955e",
	"./drop2.svg": "0afa",
	"./edit-icon.png": "58b7",
	"./edit.png": "bd52",
	"./electric.svg": "06ac",
	"./email.svg": "80f2",
	"./exchange-funds-fill.png": "ab28",
	"./footer-dot.png": "b18b",
	"./forgot-psw.png": "5ccf",
	"./game-balance.png": "655a",
	"./game-balance.svg": "832d",
	"./game.png": "8af6",
	"./hbg.svg": "ea4b",
	"./header-icon.png": "c862",
	"./help.png": "3657",
	"./herobook.png": "291d",
	"./heronium.svg": "1798",
	"./herosnake.png": "49e9",
	"./herostone.svg": "e02b",
	"./herowar.png": "8e22",
	"./history.png": "a318",
	"./home.png": "d50d",
	"./icon-add.svg": "605f",
	"./icon-arrow.svg": "a47d",
	"./icon-buy.svg": "a00a",
	"./icon-connect.png": "ecc1",
	"./icon-ctrl.svg": "7e65",
	"./icon-damage.svg": "ec9e",
	"./icon-drop.svg": "016f",
	"./icon-game.svg": "4c79",
	"./icon-heal.svg": "cb74",
	"./icon-line-svg.svg": "4edc",
	"./icon-line.png": "382a",
	"./icon-logout.png": "55fe",
	"./icon-menu.png": "1b70",
	"./icon-question.svg": "5d28",
	"./icon-search.svg": "6a1a",
	"./icon-speed.svg": "d503",
	"./icon-swap.svg": "2570",
	"./icon-title-agency.svg": "227e",
	"./icon-title-land.svg": "d5c6",
	"./icon-trade.svg": "6adb",
	"./inventory.svg": "f17b",
	"./key-icon.png": "afac",
	"./land.svg": "a7e1",
	"./login.png": "37ad",
	"./login2.png": "853a",
	"./logoHSN.svg": "7c48",
	"./logout.png": "41ff",
	"./logout.svg": "c5d0",
	"./logout2.png": "d2ec",
	"./mail-icon.png": "370e",
	"./market.png": "f149",
	"./mars.png": "9cdb",
	"./member.png": "bfe9",
	"./menu.png": "56b4",
	"./more.png": "8f3f",
	"./neon-rhombus.png": "0733",
	"./next.png": "06c8",
	"./open.png": "bb30",
	"./oxygen.svg": "7340",
	"./pencil.svg": "7576",
	"./plus.svg": "6cf9",
	"./prev.png": "7f9a",
	"./promotion.png": "15e5",
	"./referral.svg": "6627",
	"./refesh-icon.svg": "de09",
	"./right-arrow.png": "2ab9",
	"./round_check.svg": "8095",
	"./sale.png": "f6e2",
	"./search-2.png": "797e",
	"./search-new.svg": "1376",
	"./search.png": "13b1",
	"./setting.png": "ee97",
	"./setting.svg": "f754",
	"./shop.png": "627f",
	"./show-qr.svg": "487c",
	"./summon.png": "bcdf",
	"./summon.svg": "ec57",
	"./support.png": "d8d3",
	"./supportSend.svg": "a731",
	"./swap.svg": "979e",
	"./two-arrow-down.png": "78d8",
	"./two-arrow-left.png": "8484",
	"./two-arrow-right.png": "08fa",
	"./upgrade.png": "4ce3",
	"./user.png": "0262",
	"./vaccin.svg": "3d1d",
	"./vacxin.svg": "d319",
	"./wallet.png": "ac57",
	"./white-rhombus.png": "2ddb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";